// FaqOne.js
import React, { useState } from 'react';
import CounterUp from 'react-countup'; // Make sure you have this installed
import faqImg from '../../assets/images/resources/faq-3.jpg';
import faqImg1 from '../../assets/images/resources/faq2.png';

export default function FaqOne() {
  const [isActive, setIsActive] = useState({ status: false, key: null });

  const handleToggle = (key) => {
    if (isActive.key === key) {
      setIsActive({ status: false , key:null});
    } else {
      setIsActive({ status: true, key });
    }
  };

  return (
    <section className="faq-one">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div className="faq-one__left">
              <div className="section-title text-left">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">Ask question</span>
                </div>
                <h2 className="section-title__title">
                    Revolutionizing For <br />Technology<span> Future </span>
                    </h2>
              </div>
              <div className="accrodion-grp faq-one-accrodion" data-grp-name="faq-one-accrodion-1">
                
                <div className={`accrodion ${isActive.key === 1 ? 'active' : ''}`} onClick={() => handleToggle(1)}>
                  <div className="accrodion-title">
                    <h4>Why is cybersecurity important?</h4>
                  </div>
                  <div className="accrodion-content" style={{ display: isActive.key === 1 ? 'block' : 'none' }}>
                    <div className="inner">
                      <p>As our reliance on digital technology and the internet grows, so do the risks of cyber threats. Cybersecurity is essential for protecting sensitive data, maintaining privacy, and ensuring the integrity and functionality of systems and networks.</p>
                    </div>
                  </div>
                </div>
                <div className={`accrodion ${isActive.key === 2 ? 'active' : ''}`} onClick={() => handleToggle(2)}>
                  <div className="accrodion-title">
                    <h4>How can individuals protect themselves online?</h4>
                  </div>
                  <div className="accrodion-content" style={{ display: isActive.key === 2 ? 'block' : 'none' }}>
                    <div className="inner">
                      <p>Use strong, unique passwords and change them regularly.Enable two-factor authentication (2FA) where possible.Keep software and systems updated with the latest security patche.</p>
                    </div>
                  </div>
                </div>
                <div className={`accrodion ${isActive.key === 3 ? 'active' : ''}`} onClick={() => handleToggle(3)}>
                  <div className="accrodion-title">
                    <h4>What is encryption and why is it important?</h4>
                  </div>
                  <div className="accrodion-content" style={{ display: isActive.key === 3 ? 'block' : 'none' }}>
                    <div className="inner">
                      <p>Encryption is the process of transforming data into a coded format to prevent unauthorized access. It is crucial because it safeguards sensitive information from being intercepted and read by cybercriminals.</p>
                    </div>
                  </div>
                </div>
                <div className={`accrodion ${isActive.key === 4 ? 'active' : ''}`} onClick={() => handleToggle(4)}>
                  <div className="accrodion-title">
                    <h4>What is the role of AI in cybersecurity?</h4>
                  </div>
                  <div className="accrodion-content" style={{ display: isActive.key === 4 ? 'block' : 'none' }}>
                    <div className="inner">
                      <p>AI and machine learning can help identify patterns and anomalies in large datasets, enabling quicker detection of threats and automated responses to cyber incidents. They can also assist in predictive analysis to anticipate potential threats.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="faq-one__right">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="faq-one__img-1">
                    <img src={faqImg1} alt="" />
                  </div>
                  {/* <div className="faq-one__count-box">
                    <div className="faq-one__icon">
                      <span className="icon-Group"></span>
                    </div>
                    <div className="faq-one__count-inner count-box">
                      <div className="faq-one__count count-box">
                        <h3 className="count-text">
                            <CounterUp end={5} />
                        </h3>
                        <span>k</span>
                        <span>+</span>
                      </div>
                      <p>Trusted Customer</p>
                    </div>
                  </div> */}
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="faq-one__img-2">
                    <img src={faqImg} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
